<div class="white-box not-authorized"> 
  <h3><i class="fas fa-lock"></i> Forbidden</h3> 
  <p>You are not authorized to view this page.</p>
  <hr>
  <a href="#" class="back-link">Go back to dashboard</a>
</div>